/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import { AppError } from './AppError';

export class LpExpiredError extends AppError {
    TAG: string = 'LpExpiredError';

    constructor(message?: string, code?: string) {
        super(code || '', message || 'License Plate code expired.');
    }
}
